module.exports = __webpack_public_path__ + "static/media/covid-desktop-fr.b71fa906.jpg";